import { render } from "./Configs.vue?vue&type=template&id=8aa67484&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8aa67484"

export default script